import { CARoleDetail } from "@/models/typing"
import { fetchRoleInfoState } from "@/models/userState"
import { useRecoilValueLoadable } from "recoil"
import './index.scss'
import { checkPlateformType, isMobile } from "@/utils/util"


const UserInfo = () => {

    const { state, contents } = useRecoilValueLoadable<CARoleDetail>(fetchRoleInfoState)

    const limitString = (str: string) => {
        if (str.length <= 6) {
            return str;
        } else {
            return str.slice(0, 6) + '...';
        }
    }


    switch (state) {
        case 'hasValue':
            if (contents.isLogin === 1) {
                if (contents.isBind === 1) {
                    return (
                        <p>{`您好， ${limitString(contents.roleName)} ${contents.areaName}`}
                            <span onClick={() => {
                                openUrl(contents.qqBindUrl)
                                // window.open(contents.qqBindUrl, '_blank')
                            }}>【更换角色】</span>
                            <span onClick={() => {
                                openUrl(contents.qqUnBindUrl)
                                // window.open(contents.qqUnBindUrl, '_blank')
                            }}>【解除绑定】</span>
                        </p>
                    )
                } else {
                    return (
                        <p>{`您好，${contents.username}`}
                            <span onClick={() => {
                                openUrl(contents.qqBindUrl)
                                // window.open(contents.qqBindUrl, '_blank')
                            }}>【绑定角色】</span>
                        </p>
                    )
                }
            } else {
                return <p>您好，<span onClick={() => {
                    goLogin()
                }}>【登录】</span></p>
            }
        case 'loading':
            return <p>...</p>
        default:
            return <p>您好，<span onClick={() => {
                goLogin()
            }}>【登录】</span></p>
    }

}


export const MobileUserInfoLabel = () => {
    return (
        <div className={isMobile() ? "mobile-user-info" : "pc-user-info"}>
            <UserInfo />
        </div>
    )
}

function openUrl(url: string) {
    if (isMobile()) {
        window.location.href = url
    } else {
        window.open(url, '_blank')
    }
}


export function goLogin() {

    const browser = checkPlateformType()
    if (browser.versions.isApp) {
        //@ts-ignore
        dsBridgeController("login", '', function (res) { })
    } else if (browser.versions.mobile) {
        window.location.href = `//bbs.colg.cn/member.php?mod=logging&action=login&referer=${window.location.href}`
    } else {
        let url = `//bbs.colg.cn/member.php?mod=logging&action=login&referer=${window.location.href}`
        window.open(url, '_self');
        document.cookie = 'reg_pc=' + JSON.stringify({ 'a': '6', 'b': '33' }) + ';path=/;expires=Fri, 31 Dec 2999 23:59:59 GMT;domain=.bbs.colg.cn';
    }
}
